<template>
   <div :class="['avatar', { hero, profile }]">
      <Image
         v-if="getAvatar"
         class="headshot"
         :image="getAvatar"
         :key="getAvatar?.src"
         fit="cover"
      />
      <h4 v-else-if="initials" class="initials sans">{{ initials }}</h4>
   </div>
</template>

<script setup lang="ts">
const authStore = useAuthStore();
const { getAvatar, getUser } = storeToRefs(authStore);
// TODO: Change this to a single prop
const props = defineProps({
   hero: { type: Boolean, default: false },
   profile: { type: Boolean, default: false },
});

const initials = computed(() => {
   const str = getUser.value?.name;

   const match = str && str.match(/\b(\w)/g); // ['I','N','I','T','I','A','L','S']
   return match?.length ? match.join("").toUpperCase() : "JCC";
});
</script>

<style lang="scss">
@import "~/assets/scss/partials/avatar";
</style>
